// extracted by mini-css-extract-plugin
export default {"signChoiceButton":"loginChoiceButton_signChoiceButton__B9SXV"};